// Auto-cycle images on mobile — Symmetry native cards (homepage collection grid)
if (window.innerWidth <= 768) {
  document.querySelectorAll('[class*="ai-product-card__image-wrapper"]').forEach(function(wrapper) {
    const images = wrapper.querySelectorAll('img');
    if (images.length < 2) return;
    
    let showingSecond = false;
    setInterval(function() {
      if (showingSecond) {
        images[1].style.opacity = '0';
      } else {
        images[1].style.opacity = '1';
      }
      showingSecond = !showingSecond;
    }, 3000);
  });
}

// Auto-cycle images on mobile — BB custom colourway grid section
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 768) {
    document.querySelectorAll('.bb-grid__image-wrap').forEach(function(wrapper) {
      const primary = wrapper.querySelector('.bb-grid__image--primary');
      const hover = wrapper.querySelector('.bb-grid__image--hover');
      if (!primary || !hover) return;

      let showingHover = false;
      setInterval(function() {
        if (showingHover) {
          primary.style.opacity = '1';
          hover.style.opacity = '0';
        } else {
          primary.style.opacity = '0';
          hover.style.opacity = '1';
        }
        showingHover = !showingHover;
      }, 3000);
    });
  }
});